import {Action} from '@ngrx/store';
import {type} from '../utilities/type';
import {Device} from '../models/device';

export const deviceAvailableActionTypes = {
  LOAD_BY_CLIENT: type('[Device Available] Load by client'),
  LOAD: type('[Device Available] Load'),
  LOAD_SUCCESS: type('[Device Available] Load Success'),
  LOAD_FAIL: type('[Device Available] Load Error'),
  UPDATE: type('[Device Available] Update')
};

export class LoadDeviceAvailableAction implements Action {
  readonly type = deviceAvailableActionTypes.LOAD;
  constructor(public payload?: number) {}
}
export class LoadDeviceAvailableByClientAction implements Action {
  readonly type = deviceAvailableActionTypes.LOAD_BY_CLIENT;
  constructor(public payload?: {productID: number , client: string , order: string }) {}
}

export class LoadDeviceAvailableSuccessAction implements Action {
  readonly type = deviceAvailableActionTypes.LOAD_SUCCESS;
  constructor(public payload?: Device[]) {}
}

export class LoadDeviceAvailableFailAction implements Action {
  readonly type = deviceAvailableActionTypes.LOAD_FAIL;
  constructor(public payload?: string) {}
}

export class LoadDeviceAvailableUpdateAction implements Action {
  readonly type = deviceAvailableActionTypes.UPDATE;
  constructor(public payload?: string) {}
}
